import Applicants from "@/pages/recruit/candidates/Applicants.tsx";
import { HiringPlanPage } from "@/pages/recruit/hiring-plan/HiringPlanPage.tsx";
import { JobEditPage } from "@/pages/recruit/jobs/edit/JobEditPage.tsx";
import JobsIndex from "@/pages/recruit/jobs/JobsIndex.tsx";
import { ScoreCardEdit } from "@/pages/recruit/scorecards/edit/ScoreCardEdit.tsx";
import { FeedbackScoreCard } from "@/pages/recruit/scorecards/feedback/FeedbackScoreCard.tsx";
import { ScoreCardsIndex } from "@/pages/recruit/scorecards/ScoreCardsIndex.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";

export const recruitmentRoutes: RouteConfig[] = [
  {
    path: "/recruitment",
    allOfPermissions: [ApiPermission.recruiting_module],
    planFeature: ApiFeatureType.ats,
    children: [
      {
        path: "jobs",
        children: [
          { path: "", element: <JobsIndex /> },
          {
            path: ":id/edit/:step?",
            element: <JobEditPage />,
            isFullScreen: true,
            allOfPermissions: [ApiPermission.manage_jobs],
          },
          {
            path: "new",
            element: <JobEditPage />,
            isFullScreen: true,
            allOfPermissions: [ApiPermission.manage_jobs],
          },
        ],
      },
      {
        path: "hiring-plan",
        element: <HiringPlanPage />,
        anyOfViewPermissions: [ApiPermission.manage_hiring_plan],
        planFeature: ApiFeatureType.ats_hiring_plan,
      },
      {
        path: "scorecards",
        anyOfViewPermissions: [ApiPermission.ats_manage_scorecards],
        children: [
          {
            path: "",
            element: <ScoreCardsIndex />,
          },
          {
            path: ":id/setup/:step?",
            element: <ScoreCardEdit />,
            isFullScreen: true,
          },
        ],
      },
      {
        path: "candidates",
        children: [
          { path: "", element: <Applicants /> },
          { path: ":id", element: <Applicants /> },
          { path: ":id/notes", element: <Applicants /> },
          {
            path: ":candidate_id/feedbacks/:feedback_id",
            element: <FeedbackScoreCard />,
            isFullScreen: true,
          },
        ],
      },
    ],
  },
];
